import { useIsUsageEnabled } from "src/components/lineage/use-is-usage-enabled";
import { useLocation, useSearchParams } from "src/router";

const USAGE_COLUMN_PARAM = "usageColumn";

export type ColumnUsageState = {
  openColumn: string | null;
  open: (columnName: string) => void;
  close: () => void;
};

export function useColumnUsage(): ColumnUsageState {
  const isUsageEnabled = useIsUsageEnabled();
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();

  const update = (columnName: string | null) => {
    const params = new URLSearchParams(searchParams);
    if (columnName === null) {
      params.delete(USAGE_COLUMN_PARAM);
    } else {
      params.set(USAGE_COLUMN_PARAM, columnName);
    }
    setSearchParams(params, { state: location.state });
  };

  return {
    openColumn: isUsageEnabled
      ? searchParams.get(USAGE_COLUMN_PARAM) || null
      : null,
    open: (columnName: string) => update(columnName),
    close: () => update(null),
  };
}
